import client from '../client'

export async function startConversation({ userId, topic, vehicleId = '' }) {
  const body = {
    withUserId: userId,
    topic,
    vehicleId,
  }

  return client(`${process.env.NEXT_PUBLIC_CHAT_DOMAIN}/api/Chat/StartConversation`, {
    headers: { 'content-type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(body),
  })
}
